import { forwardRef } from "react";
import {
  Controller,
  FieldErrors,
  FieldValues,
  useFormContext,
} from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { Input } from "@chakra-ui/react";
import { Field } from "../ui/field.tsx";
import { InputGroup } from "../ui/input-group.tsx";

export type ControlledDatePickerProps = {
  label?: string;
  placeholder?: string;
  name: string;
  className?: string;
  id?: string;
  errors?: FieldErrors<FieldValues>;
  disabled?: boolean;
  defaultValue?: Date | null;
  size?: "xs" | "sm" | "md" | "lg";
  showError?: boolean;
};

const ControlledDatePicker = forwardRef<
  HTMLInputElement,
  ControlledDatePickerProps
>(
  ({
    placeholder,
    name = "",
    disabled = false,
    id,
    defaultValue = null,
    size = "sm",
    label,
    className,
    showError = true,
  }) => {
    const { control } = useFormContext();

    return (
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        render={({ field, fieldState: { error } }) => (
          <InputGroup className={className} zIndex={1000}>
            <Field
              invalid={!!error?.message}
              label={label}
              color={"#000000"}
              errorText={showError ? error?.message : undefined}
            >
              <DatePicker
                id={id}
                selected={field.value}
                onChange={field.onChange}
                className={"w-[30rem] z-[100]"}
                placeholderText={placeholder}
                customInput={
                  <Input
                    disabled={disabled}
                    size={size}
                    width={"w-[30rem]"}
                    variant="outline"
                    borderWidth="1px"
                    borderColor="#d3d3d3"
                    fontSize="14px"
                    borderRadius="0.5rem"
                    paddingLeft="0.5rem"
                  />
                }
                dateFormat="dd/MM/yyyy"
                disabled={disabled}
              />
            </Field>
          </InputGroup>
        )}
      />
    );
  },
);

ControlledDatePicker.displayName = "ControlledDatePicker";

export default ControlledDatePicker;
